'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { LanguageProvider } from '@/app/_i18n/LanguageContext.jsx'
import ScrollToTop from '@/app/_components/ScrollToTop.jsx'

/**
 * HashRedirect — temporary compatibility shim for legacy SPA hash links.
 *
 * During the Vite→Next migration, some external sites still link to
 * `/#/products`, `/#/news/123`, `/#/admin`, etc.  URL fragments are
 * never sent to the server, so this client component normalises them
 * on first paint via router.replace (no history pollution).
 *
 * Remove once all inbound links have been updated.
 */
function HashRedirect() {
  const router = useRouter()

  useEffect(() => {
    const hash = window.location.hash
    if (!hash || !hash.startsWith('#/')) return

    const canonical = hash.replace(/^#/, '') // '#/products' → '/products'
    router.replace(canonical)
  }, [router])

  return null
}

export default function Providers({ children }) {
  return (
    <LanguageProvider>
      <HashRedirect />
      <ScrollToTop />
      {children}
    </LanguageProvider>
  )
}